export default function SpinnerNormal() {
  return <div className="spinner-border text-info"></div>;
}
